<div class="w-full h-full flex items-stretch {{ class }}">
  <div
    class="w-full card !py-3 !px-3 cursor-pointer d-flex justify-between"
    [ngClass]="{ 'selected-card': control?.value === value }"
    (click)="select()"
  >
    <div class="d-flex gap-x-2 align-items-center w-fit">
      <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
      <div class="flex-col justify-between align-items-start">
        <label class="orgbrain-text">{{ label }}</label>
        <p *ngIf="labelText" class="orgbrain-small-gray-text">{{ labelText }}</p>
      </div>
    </div>

    <input
      type="radio"
      class="!mx-1 !my-1"
      [value]="value"
      [checked]="control?.value === value"
      [disabled]="disabled"
    />
  </div>
</div>
